var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMysizeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 168.967,
    height: 34,
    viewBox: "0 0 168.967 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    style: {
      fill: "none"
    },
    d: "M0 0h168.967v34H0z"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n            .cls-3{fill:#f1686f}.cls-4{fill:#201c51}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    style: {
      clipPath: "url(#clip-path)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    className: "cls-3",
    d: "M43.577 16.619V0h-15a18.242 18.242 0 0 0 15 16.619",
    transform: "translate(-9.577)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    className: "cls-3",
    d: "M17.338 0H0v34h34V18.307A19.908 19.908 0 0 1 17.338 0m-.674 20.9H8.628a.831.831 0 1 1 0-1.662h8.036a.831.831 0 1 1 0 1.662m14.257 8.056a.986.986 0 1 1 .767-1.163.985.985 0 0 1-.767 1.163m0-4.3a.985.985 0 1 1 .767-1.163.985.985 0 0 1-.767 1.163"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    className: "cls-4",
    d: "M135.551 29.54a2.839 2.839 0 0 0-.709-2.1 8.172 8.172 0 0 0-2.579-1.473 12.015 12.015 0 0 1-4.908-3.031 6.094 6.094 0 0 1-1.5-4.106 5.758 5.758 0 0 1 2.033-4.6 8.45 8.45 0 0 1 8.891-.857 6.109 6.109 0 0 1 2.516 2.485 7.46 7.46 0 0 1 .88 3.646h-4.565a3.765 3.765 0 0 0-.678-2.422 2.374 2.374 0 0 0-1.956-.834 2.449 2.449 0 0 0-1.87.709 2.666 2.666 0 0 0-.67 1.909 2.355 2.355 0 0 0 .747 1.691 8.627 8.627 0 0 0 2.649 1.567 11.356 11.356 0 0 1 4.824 2.944 6.563 6.563 0 0 1 1.5 4.441 5.86 5.86 0 0 1-1.885 4.628 7.463 7.463 0 0 1-5.127 1.667 8.821 8.821 0 0 1-4-.9 6.783 6.783 0 0 1-2.828-2.587 7.512 7.512 0 0 1-1.016-3.977h4.6a4.323 4.323 0 0 0 .764 2.851 3.12 3.12 0 0 0 2.492.888q2.4 0 2.4-2.539",
    transform: "translate(-41.985 -4.186)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    className: "cls-4",
    transform: "translate(102.541 8.619)",
    d: "M0 0h4.581v22.687H0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    className: "cls-4",
    d: "M172.981 31.847h9.349v3.8h-14.71v-2.756l9.256-16.111h-9.348v-3.818h14.63v2.7z",
    transform: "translate(-56.135 -4.344)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    className: "cls-4",
    d: "M207.435 25.832H200.3v6.015h8.444v3.8h-13.028V12.962h13v3.818H200.3v5.36h7.137z",
    transform: "translate(-65.58 -4.344)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    className: "cls-4",
    transform: "translate(148.977 8.619)",
    d: "M0 0h1.777v22.687H0z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "cls-4",
    d: "M233.962 35.649V12.962h5.345a7.509 7.509 0 0 1 5.843 2.361 9.524 9.524 0 0 1 2.214 6.5v4.757a9.572 9.572 0 0 1-2.174 6.668 7.812 7.812 0 0 1-6.1 2.4zm1.776-21V34h3.444a5.966 5.966 0 0 0 4.707-1.878 8 8 0 0 0 1.712-5.367V22a8.174 8.174 0 0 0-1.628-5.424 5.818 5.818 0 0 0-4.712-1.932z",
    transform: "translate(-78.396 -4.344)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    className: "cls-4",
    d: "m66.926 13.055 6.888 20.007 6.919-20.007h2.358v22.74h-1.78V25.94l.157-9.917L74.5 35.795h-1.373l-6.934-19.679.156 9.762v9.917h-1.781v-22.74z",
    transform: "translate(-21.635 -4.375)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    className: "cls-4",
    d: "m106.827 25.424 5.668-12.37h2.046L107.7 27.236V35.8h-1.78v-8.564L99.1 13.054h2.093z",
    transform: "translate(-33.205 -4.374)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    className: "cls-3",
    transform: "translate(102.541 2.158)",
    d: "M0 0h4.581v4.582H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMysizeIcon);
export default __webpack_public_path__ + "static/media/mysize-icon.f78ea84d.svg";
export { ForwardRef as ReactComponent };